import {
  Directive,
  Renderer2,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';

@Directive({
  selector: '[appPhoneFormatter]',
})
export class PhoneFormatterDirective {
  @Output() valueChange = new EventEmitter();

  constructor(public renderer: Renderer2, public el: ElementRef) {}

  @HostListener('input', ['$event.target.value']) onInput(e: string) {
    this.format(e);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event?.clipboardData?.getData('text/plain') || '');
  }

  format(val: string) {
    // Remove all non-numeric characters
    let cleaned = val.replace(/\D/g, '');

    // Remove +56 prefix if it exists in the input
    if (cleaned.startsWith('56')) {
      cleaned = cleaned.substring(2);
    }

    // Limit to 10 digits
    if (cleaned.length > 10) {
      cleaned = cleaned.substring(0, 10);
    }

    // Create display value with +56 prefix
    const displayValue = cleaned.length > 0 ? `+56${cleaned}` : '';

    // Update the input field with formatted value
    this.renderer.setProperty(this.el.nativeElement, 'value', displayValue);

    // Emit the clean value (56 + digits) for form control storage
    const cleanValue = cleaned.length > 0 ? `56${cleaned}` : '';
    this.valueChange.emit(cleanValue);
  }
}
